
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { Navigator, Service } from '@/domain/providers';
import type { Navigation } from 'zr-arch';
import Services from '@/infrastructure/service';
import QRCode from 'qrcode';

@Component({})
export default class ExamManage extends Vue {
    @Inject(Service) service!: Services;
    @Inject(Navigator) navigator!: Navigation;

    private loading = false;
    private saving = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private exams: any[] = [];
    private totalCount = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private options: any = { page: 1, itemsPerPage: 15 };
    private search = '';

    private headers = [
        { text: '序号', value: '序号', sortable: false, width: '100px' },
        { text: '考试名称', value: '考试名称', sortable: false },
        { text: '默认打款金额', value: '默认打款金额', sortable: false, width: '160px' },
        { text: '截止日期', value: '截止日期', sortable: false, width: '180px' },
        { text: '创建时间', value: '创建时间', sortable: false, width: '180px' },
        { text: '操作', value: 'actions', sortable: false, width: '200px' },
    ];

    private qrDialog = false;
    private qrUrl = '';
    private qrExamName = '';
    private deadlineMenu = false;

    private editDialog = false;
    private isEditing = false;
    private editForm = { id: '', 考试名称: '', 默认打款金额: 0, 截止日期: '' as string | null, 是否需上传身份证照片: true, 是否需填写银行卡: true };

    async mounted(): Promise<void> {
        await this.loadExams();
    }

    @Watch('search')
    async onSearchChange(): Promise<void> {
        this.options.page = 1;
        await this.loadExams();
    }

    async loadExams(): Promise<void> {
        this.loading = true;
        try {
            const params: Record<string, string> = {
                pageIndex: String(this.options.page || 1),
                pageSize: String(this.options.itemsPerPage || 15),
            };
            if (this.search) params.keyword = this.search;
            const result = await this.service.api.get('/ExpertColl/Manage/ExamManage/GetExamList', params);
            this.exams = result.data || [];
            this.totalCount = result.totalCount || 0;
        } finally {
            this.loading = false;
        }
    }

    openAddDialog(): void {
        this.isEditing = false;
        this.editForm = { id: '', 考试名称: '', 默认打款金额: 0, 截止日期: null, 是否需上传身份证照片: true, 是否需填写银行卡: true };
        this.editDialog = true;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editExam(item: any): void {
        this.isEditing = true;
        const raw = item.截止日期;
        const dateStr = raw ? String(raw).slice(0, 10) : null;
        this.editForm = {
            id: item.id,
            考试名称: item.考试名称,
            默认打款金额: item.默认打款金额,
            截止日期: dateStr,
            是否需上传身份证照片: item.是否需上传身份证照片 ?? true,
            是否需填写银行卡: item.是否需填写银行卡 ?? true,
        };
        this.editDialog = true;
    }

    async saveEdit(): Promise<void> {
        if (!this.editForm.考试名称) {
            this.service.提示.提示错误('请填写考试名称');
            return;
        }
        this.saving = true;
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const payload: any = {
                考试名称: this.editForm.考试名称,
                默认打款金额: this.editForm.默认打款金额,
                截止日期: this.editForm.截止日期 ? String(this.editForm.截止日期).slice(0, 10) : null,
                是否需上传身份证照片: this.editForm.是否需上传身份证照片,
                是否需填写银行卡: this.editForm.是否需填写银行卡,
            };
            if (this.isEditing) {
                payload.id = this.editForm.id;
                await this.service.api.post('/ExpertColl/Manage/ExamManage/UpdateExam', payload);
                this.service.提示.提示成功('修改成功');
            } else {
                await this.service.api.post('/ExpertColl/Manage/ExamManage/CreateExam', payload);
                this.service.提示.提示成功('考试创建成功');
            }
            this.editDialog = false;
            await this.loadExams();
        } finally {
            this.saving = false;
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async showQRCode(item: any): Promise<void> {
        const result = await this.service.api.get('/ExpertColl/Manage/ExamManage/GetQrCodeUrl', { examId: item.id });
        this.qrUrl = result.url;
        this.qrExamName = item.考试名称;
        this.qrDialog = true;

        this.$nextTick(() => {
            const canvas = this.$refs.qrCanvas as HTMLCanvasElement;
            if (canvas) {
                QRCode.toCanvas(canvas, this.qrUrl, { width: 512, margin: 2 }, (err: Error | null | undefined) => {
                    if (err) console.error('二维码生成失败', err);
                });
            }
        });
    }

    downloadQRCode(): void {
        const canvas = this.$refs.qrCanvas as HTMLCanvasElement;
        if (canvas) {
            const link = document.createElement('a');
            link.download = `二维码_${this.qrExamName}.png`;
            link.href = canvas.toDataURL();
            link.click();
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formatDeadline(val: any): string {
        if (!val) return '不限';
        const d = new Date(val);
        if (isNaN(d.getTime())) return String(val);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isExpired(val: any): boolean {
        if (!val) return false;
        return new Date(val).getTime() < Date.now();
    }
}
